import { Field, Formik } from 'formik'
import { ReactElement, useCallback, useEffect, useRef } from 'react'
import { useRecoilValue } from 'recoil'
import { IDeposit } from '../types/types'
import { api } from '../utils/api'
import { useAddDeposit } from '../states/deposits-state'
import { currenciesState } from '../states/currencies-state'
import { v4 } from 'uuid'
import { FormikProps } from 'formik/dist/types'
import { accountsState } from '../states/accounts-state'

interface FormErrors {
  name?: string
  codename?: string
}

const INITIAL_VALUES: Partial<IDeposit> = {
  id: undefined,
  account: undefined,
  amount: 0,
  currency: undefined,
  realizedAt: undefined,
}

interface Props {
  accountId?: string
}

/**
 *   id: string
 account: IAccount
 accountId: string
 amount: number
 currency: ICurrency
 currencyId: string
 realizedAt: Date
 * @param props
 * @constructor
 */

const DepositForm = (props: Props): ReactElement => {
  const addDeposit = useAddDeposit()
  const currencies = useRecoilValue(currenciesState)
  const accounts = useRecoilValue(accountsState)
  const formRef = useRef<FormikProps<IDeposit>>(null)
  const onSubmit = useCallback(async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
        ...values,
        id: v4(), // Generate a new id
      }

      const { data } = await api.post('deposit', payload)

      if (data.deposit) {
        resetForm()
        // Log user
        addDeposit(data.deposit)
      }
    } catch (e) {
      console.log(e)
    }
  }, [])

  useEffect(() => {
    if (
      currencies &&
      currencies.length > 0 &&
      formRef.current &&
      !formRef.current.values.currency
    ) {
      // Set default currency
      formRef.current.setFieldValue('currency', currencies[0].id)
    }
  }, [])

  return (
    <Formik initialValues={INITIAL_VALUES} onSubmit={onSubmit} innerRef={formRef}>
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        // @ts-ignore
        <form onSubmit={handleSubmit}>
          <Field
            className="select select-bordered w-full min-w-8 mb-4"
            component="select"
            id="account"
            name="account">
            <option value={undefined} title={'Select account'}>
              Select account
            </option>
            {accounts.map((account) => {
              return (
                <option key={account.id} value={account.id}>
                  {account.name}
                </option>
              )
            })}
          </Field>
          <Field
            type="currency"
            name="amount"
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Eg. 1000"
            value={values.codename}
            className="input input-bordered w-full min-w-8 mb-4"
          />
          <Field
            className="select select-bordered w-full min-w-8 mb-4"
            component="select"
            id="currency"
            name="currency">
            {currencies?.map((currency) => {
              return (
                <option key={currency.id} value={currency.id}>
                  {currency.name} ({currency.code})
                </option>
              )
            })}
          </Field>

          <button type="submit" className="btn btn-outline" disabled={isSubmitting}>
            Submit
          </button>
        </form>
      )}
    </Formik>
  )
}

export default DepositForm